// TODO:区分コード管理.xlsx参考

import commonUtil from "../../ts/util/commonUtil"
import { e記号 } from "./frontend"

/**
 * U0001	出退勤区分
 */
export const e出退勤区分 = {
  出勤: "10",
  退勤: "11",
  始業: "20",
  終業: "21",
} as const

export type T出退勤区分名称 = keyof typeof e出退勤区分
export type T出退勤区分 = (typeof e出退勤区分)[T出退勤区分名称]

// U0002 勤怠区分
export const e勤怠区分 = {
  出勤: "10",
  休日出勤: "11",
  祝日出勤: "12",
  有給休暇: "20",
  //半休は有休扱い
  午前半休: "21",
  午後半休: "22",
  特別休暇: "30",
  慶忌休暇: "31",
  所定休日: "40",
  所定出勤: "41",
  育介休暇: "50",
  育介半休: "51",
  休日: "70",
  振替休日: "80",
  代休: "81",
  欠勤: "90",
  半欠勤: "91",
} as const
export const 勤怠表示記号区分: Array<{ 区分コード: string; 表示記号: string }> = [
  {
    区分コード: "10",
    表示記号: e記号.丸,
  },
  {
    区分コード: "11",
    表示記号: e記号.丸,
  },
  {
    区分コード: "12",
    表示記号: e記号.丸,
  },
  {
    区分コード: "20",
    表示記号: "休",
  },
  {
    区分コード: "21",
    表示記号: "A",
  },
  {
    区分コード: "22",
    表示記号: "P",
  },
  {
    区分コード: "30",
    表示記号: "特",
  },
  {
    区分コード: "31",
    表示記号: "慶忌",
  },
  {
    区分コード: "40",
    表示記号: "所定",
  },
  {
    区分コード: "50",
    表示記号: "育休",
  },
  {
    区分コード: "51",
    表示記号: "育半",
  },
  {
    区分コード: "70",
    表示記号: "休日",
  },
  {
    区分コード: "80",
    表示記号: "振休",
  },
  {
    区分コード: "90",
    表示記号: "欠",
  },
]

export const 乗務員勤怠表示記号区分: Array<{
  区分コード: string
  表示記号: string
}> = [
  {
    区分コード: "1",
    表示記号: e記号.丸,
  },
  {
    区分コード: "2",
    表示記号: e記号.黒丸,
  },
  {
    区分コード: "3",
    表示記号: e記号.三角,
  },
  {
    区分コード: "4",
    表示記号: e記号.黒三角,
  },
  {
    区分コード: "20",
    表示記号: "有休",
  },
  {
    区分コード: "30",
    表示記号: "特休",
  },
]
export type T勤怠区分名称 = keyof typeof e勤怠区分
export type T勤怠区分 = (typeof e勤怠区分)[T勤怠区分名称]
export const e勤怠区分名称 = commonUtil.getReverseEnum(e勤怠区分)

export const 太字表示勤怠区分: Array<string> = [
  e勤怠区分.有給休暇,
  e勤怠区分.午前半休,
  e勤怠区分.午後半休,
  e勤怠区分.特別休暇,
  e勤怠区分.育介休暇,
  e勤怠区分.育介半休,
]

// U0003	休暇種別区分
// U0004	運行管理者区分

export const e運行管理者区分 = {
  統括運行管理者: "01",
  運行管理者1: "11",
  運行管理者2: "12",
  運行管理者3: "13",
  運行管理補助者1: "21",
  運行管理補助者2: "22",
  運行管理補助者3: "23",
  運行管理補助者4: "24",
  運行管理補助者5: "25",
  整備管理者1: "31",
  整備管理者2: "32",
  整備管理者3: "33",
  整備管理補助者1: "41",
  整備管理補助者2: "42",
  整備管理補助者3: "43",
  整備管理補助者4: "44",
  整備管理補助者5: "45",
  整備管理補助者6: "46",
} as const

export type T運行管理者区分名称 = keyof typeof e運行管理者区分
export type T運行管理者区分 = (typeof e運行管理者区分)[T運行管理者区分名称]

// U0005	天候区分

export const e天候区分 = {
  晴れ: "1",
  曇り: "2",
  雨: "3",
  雪: "4",
} as const

export type T天候区分名称 = keyof typeof e天候区分
export type T天候区分 = (typeof e天候区分)[T天候区分名称]

/**
 * U0006	点呼区分
 */
export const e点呼区分 = {
  始業点呼: "10",
  中間点呼１: "20",
  中間点呼２: "21",
  中間点呼３: "22",
  終業点呼: "30",
  始業点呼2: "40",
  終業点呼2: "50",
} as const

export type T点呼区分名称 = keyof typeof e点呼区分
export type T点呼区分 = (typeof e点呼区分)[T点呼区分名称]

// U0007	点呼方法区分
export const e点呼方法区分 = {
  対面: "1",
  電話: "2",
} as const

export type T点呼方法区分名称 = keyof typeof e点呼方法区分
export type T点呼方法区分 = (typeof e点呼方法区分)[T点呼方法区分名称]

// U0008	指示事項区分

/**
 * 点呼確認内容フラグ
 *
 * フラグの0,1がわかりにくいため定義
 */
export namespace e点呼確認 {
  export const 日常点検 = {
    OK: 1,
    未実施: 0,
  }

  export const 免許証フラグ = {
    OK: 1,
    不携帯: 0,
  }

  export const 酒気帯びフラグ = {
    OK: 0,
    酒気帯: 1,
  }

  export const 検知器使用フラグ = {
    未使用: 0,
    使用: 1,
  }

  export const 疲労疾病フラグ = {
    OK: 0,
    疲労: 1,
  }

  export const 睡眠不足フラグ = {
    OK: 0,
    睡眠不足: 1,
  }
}

/**
 * U0017 乗務員所定労働時間区分
 */
export const e乗務員所定労働時間区分 = {
  基準労働時間: "1",
  月間基準労働時間: "2",
} as const

export type T乗務員所定労働時間区分名称 = keyof typeof e乗務員所定労働時間区分
export type T乗務員所定労働時間区分 = (typeof e乗務員所定労働時間区分)[T乗務員所定労働時間区分名称]
